module.exports = __webpack_public_path__ + "img/Artboard 3.6a3bc165.png";